<script setup lang="ts">

import type { Group } from "@/stores/groups.ts";
import GroupTableItem from "@/components/group/GroupTableItem.vue";

const props = defineProps<{
  group: Group
}>();

</script>

<template>
  <div class="group-table">
    <h2>{{ props.group.name }}</h2>
    <table>
      <thead>
        <tr>
          <th>Platz</th>
          <th>Team</th>
          <th>Punkte</th>
          <th>(G|U|V)</th>
          <th>Tore</th>
        </tr>
      </thead>
      <tbody>
        <GroupTableItem
          v-for="(placement, index) in props.group.placements"
          :key="index"
          :placement="placement"
        />
      </tbody>
    </table>
  </div>
</template>

<style scoped>

.group-table table {
  width: 100%;
  border-collapse: collapse;
}

</style>

<style>
@media (max-width: 600px) {
  .group-table table {
    th:nth-child(4),
    td:nth-child(4),
    th:nth-child(5),
    td:nth-child(5) {
      display: none;
      visibility: hidden;
    }
  }
}
</style>
